import { MessageBox } from 'element-ui';
import logger from '@/modules/Logger';
import i18n from '@/lang/_i18n';

export default {
  async playRemoteAudioTrack() {
    try {
      // Agora does not accept audio element as param
      // It internally plays audio via the Web Audio API or system audio output
      this.remoteUserRtc.audioTrack.play();
    } catch (err) {
      logger.debug('[Agora] Failed to autoplay remote audio: ', err);
      
      await MessageBox.alert(
        i18n.t('autoplayNotif.content'),
        i18n.t('autoplayNotif.title'),
        {
          confirmButtonText: 'Play Audio',
          type: 'warning',
          dangerouslyUseHTMLString: true,
          closeOnClickModal: false,
          closeOnPressEscape: false
        }
      );

      this.remoteUserRtc.audioTrack.play();
    }
  }
};
